module.exports = __webpack_public_path__ + "static/media/pagorapido.f76d17d5.svg";